import React from "react";
import { FaExclamationTriangle, FaTimes } from "react-icons/fa";

const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  itemName,
  usageInfo = [],
  title = "This image is in use",
  description = "Deleting it will affect the elements below:",
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/60 backdrop-blur-sm">
      <div className="relative bg-[#4C4563] backdrop-blur-md text-white rounded-2xl p-8 w-full max-w-lg mx-4 shadow-2xl border border-gray-700/50">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 hover:bg-gray-700/50 rounded-full transition-colors"
        >
          <FaTimes className="w-5 h-5 text-gray-400 hover:text-white" />
        </button>

        {/* Warning Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center">
            <FaExclamationTriangle className="w-8 h-8 text-red-500" />
          </div>
        </div>

        {/* Title */}
        <h2 className="text-2xl font-semibold text-center mb-4">{title}</h2>

        {/* Description */}
        <p className="text-gray-300 text-center mb-6">{description}</p>

        {/* Usage List */}
        {usageInfo.length > 0 && (
          <div className="mb-8">
            <p className="text-gray-300 mb-3">Used by ({usageInfo.length}):</p>
            <ul className="space-y-2">
              {usageInfo.map((usage, index) => (
                <li key={index} className="flex items-center text-gray-300">
                  <span className="w-2 h-2 bg-gray-500 rounded-full mr-3"></span>
                  {usage}
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Action Buttons */}
        <div className="flex gap-4">
          <button
            onClick={onClose}
            className="flex-1 py-3 px-6 bg-red-600 hover:bg-red-700 text-white font-medium rounded-lg transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 py-3 px-6 border-2 border-red-600 text-red-400 hover:bg-red-600/10 font-medium rounded-lg transition-colors"
          >
            Move to Trash
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
